import { useLoaderData, useLocation } from "@remix-run/react";
import type { TravelPost } from "../data/travelPosts";
import { pathnameToIntValue } from "../lib/utils";
import { Layout } from "./Layout";
import { TravelHeader } from "./TravelHeader";
import { TravelPolaroid } from "./TravelPolaroid";

export interface TravelListingLoaderProps {
	countrySlug: string | null;
	townSlug: string | null;
	posts: TravelPost[];
}

// TODO: This is kinda grim. Consider smaller components, or accepting some duplication
export function getTravelListingComponent({
	getPostProps,
}: {
	getPostProps: (post: TravelPost) => { title: string; to: string };
}) {
	return function TravelListing() {
		const props = useLoaderData<TravelListingLoaderProps>();
		const location = useLocation();
		const pathnameIntValue = pathnameToIntValue(location.pathname);

		return (
			<Layout>
				<main>
					<TravelHeader {...props} />
					<ul className="grid gap-12 px-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
						{props.posts.map((post, i) => (
							<li key={post.mainImage.src.medium}>
								<TravelPolaroid
									key={post.mainImage.src.medium}
									imageLoading={i < 4 ? "eager" : "lazy"}
									// The visual randomness of the polaroids is based on the pathname,
									// so it is predictable and rendered the same on the server and client.
									// But it changes when viewing a different listing page.
									randomSeed={pathnameIntValue + i}
									image={post.mainImage}
									{...getPostProps(post)}
								/>
							</li>
						))}
					</ul>
				</main>
			</Layout>
		);
	};
}
